
export async function getPersonalizedMessage(templateText, patientData) {
  const apiKey = process.env.REACT_APP_ANTHROPIC_KEY

  if (!apiKey) {
    return templateText
  }

  const prompt = `You are a helpful cardiac health coach working for Heart Rhythm Center.
Your job is to personalize a coaching message for a patient managing atrial fibrillation (AFib).

Here is the base message template:
"${templateText}"

Here is relevant patient data:
- Age: ${patientData.age || 'unknown'}
- Sex: ${patientData.sex || 'unknown'}
- Exercise today: ${patientData.exercise_minutes || 0} minutes (${patientData.exercise_intensity || 'none'})
- Sleep last night: ${patientData.sleep_hours || 0} hours
- Alcohol today: ${patientData.alcohol_level || 'none'}
- Caffeine today: ${patientData.caffeine_level || 'none'}
- Anticoagulation taken: ${patientData.anticoag_taken ? 'yes' : 'no'}
- Current weight: ${patientData.current_weight || 'unknown'} lbs
- Baseline weight: ${patientData.baseline_weight || 'unknown'} lbs
- Blood pressure: ${patientData.bp_systolic || 'unknown'}/${patientData.bp_diastolic || 'unknown'}
- Has hypertension: ${patientData.htn ? 'yes' : 'no'}
- Has diabetes: ${patientData.diabetes ? 'yes' : 'no'}
- Goal timeframe: ${patientData.goal_timeframe || 'unknown'}

Instructions:
- Keep the same core medical message and advice from the template
- Personalize by weaving in 1 specific data point that is DIRECTLY relevant to this particular message category only
- For example: an alcohol message should reference alcohol data, a sleep message should reference sleep hours, an exercise message should reference exercise minutes
- Do not cross-reference unrelated categories in other messages
- Keep the tone warm, encouraging, and supportive
- Keep the response to 2-3 sentences maximum
- Do not change any medical facts or recommendations from the template
- Do not mention the patient's name
- Return only the personalized message text, nothing else`

  try {
    const response = await fetch('https://api.anthropic.com/v1/messages', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
        'anthropic-version': '2023-06-01',
        'anthropic-dangerous-direct-browser-access': 'true'
      },
      body: JSON.stringify({
        model: 'claude-sonnet-4-20250514',
        max_tokens: 200,
        messages: [{ role: 'user', content: prompt }]
      })
    })

    const data = await response.json()

    if (data.content && data.content[0] && data.content[0].text) {
      return data.content[0].text.trim()
    } else {
      return templateText
    }
  } catch (error) {
    return templateText
  }
}